import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";

import WithSpinner from "../../components/withSpinner/withSpinner.component";
import SettingsView from "./views/SettingsView";

const mapStateToProps = createStructuredSelector({
  isLoading: (state) => !state.user.currentUser,
});

const SettingsContainer = compose(
  connect(mapStateToProps),
  WithSpinner
)(SettingsView);

export default SettingsContainer; 